import { defineStore } from 'pinia'
import apiService from '@/services/apiService';

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        loading: false,
        error: null,
        settings: null,
    }),

    actions: {
        async fetchSettings() {
            this.loading = true
            this.error = null
            try {
                const response = await apiService.get('/settings')
                this.settings = response.data
            } catch (err) {
                this.error = err
                console.error('Błąd przy pobieraniu ustawien:', err)
            } finally {
                this.loading = false
            }
        },

        async updateSettings(data) {
            this.loading = true
            this.error = null
            try {
                const response = await apiService.post('/settings', data)
                this.settings = response.data
                await this.fetchSettings()
            } catch (err) {
                this.error = err
                console.error('Błąd przy edycji ustawień', err)
            } finally {
                this.loading = false
            }
        }
    },
})